import { schema } from "normalizr";
import { arrayOfAttachments } from "./schema.attachments.jsx";
import { arrayOfReactions } from "./schema.reactions.jsx";

const conversation_message = new schema.Entity(`conversation_messages`);
const arrayOfConversationMessages = [conversation_message];

conversation_message.define({
  attachments: arrayOfAttachments,
  reactions: arrayOfReactions,
});

export { conversation_message, arrayOfConversationMessages };
